import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import 'firebase/firestore';
import { db } from '../../../firebase';

const LineChart = () => {
  const [admin, setAdmin] = useState('');
  const [handleTime, setHandleTime] = useState([]);

  const chartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Handle Time',
        data: [20, 40, 60, 10,50,10,5,15,22,10,12,11],
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };
  const options = {
  legend: {
    display: true,
    position: "bottom",
    labels: {
      fontColor: "#333",
      fontSize: 12,
      usePointStyle: true,
    },
  },
  responsive: true,
  maintainAspectRatio: true,
};

  return (
    <div style={{width:'100%'}}>
      <FormControl fullWidth>
        <InputLabel id="admin-select-label">Select Admin</InputLabel>
        <Select
          labelId="admin-select-label"
          id="admin-select"
          value={admin}
          label="Select Admin"
          onChange={(event) => setAdmin(event.target.value)}
        >
          <MenuItem value="">Select Admin</MenuItem>
          <MenuItem value="John Doe">John Doe</MenuItem>
          <MenuItem value="Jane Smith">Jane Smith</MenuItem>
          {/* Add more admins as needed */}
        </Select>
      </FormControl>
      <Bar data={chartData} options={options}/>
    </div>
  );
};

export default LineChart;
